export const TIPS_SOURCE = {
    POS: 'POS',
    TIP_FILE: 'TIP_FILE',
};

export const TIPS_DISTRIBUTION_SOURCE_VIEW = {
    PDS: 'PDS',
    TIMESHEET: 'TIMESHEET',
};